import React, { createContext, useState, useCallback, useContext } from 'react';

import { storageKey } from '~/utils';

import { ThemeState, AppThemeContextProps } from './interface';

const AppThemeContext = createContext<AppThemeContextProps>(
  {} as AppThemeContextProps,
);

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentTheme, setCurrentTheme] = useState<ThemeState>(() => {
    const storedTheme = localStorage.getItem(storageKey('theme')) as ThemeState;
    return storedTheme ? JSON.parse(storedTheme) : 'light';
  });

  const toggleTheme = useCallback(() => {
    setCurrentTheme(prevTheme => {
      const newTheme = prevTheme === 'light' ? 'dark' : 'light';
      localStorage.setItem(storageKey('theme'), JSON.stringify(newTheme));

      return newTheme;
    });
  }, []);

  const value = React.useMemo(
    () => ({
      currentTheme,
      toggleTheme,
    }),
    [currentTheme, toggleTheme],
  );

  return (
    <AppThemeContext.Provider value={value}>
      {children}
    </AppThemeContext.Provider>
  );
};

const useAppTheme = (): AppThemeContextProps => {
  const context = useContext(AppThemeContext);

  if (!context) {
    throw new Error(`Use o Hook de temas dentro do provedor!`);
  }

  return context;
};

export default useAppTheme;
